import React from "react";
import "../styles/styles.scss";
import "../styles/custom.css";
import Filter from "./filter";
import Products from "./products";
import api from "../services/products";
import {
  getFilter,
  setActiveFilterId,
  setRequest,
  getProducts,
} from "../store/reducers/filterSlice";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import { unflattenQueryString } from "../util/flattenObject";
import Powers from "./filter/powers.jsx";
import Allunits from "./filter/allunits.jsx";

class List extends React.Component {
  state = {
    filters: [],
    activeFilter: 0,
    request: {},
    products: [],
    productsCount: 0,
    selectedOptions: {},
    searched: "",
    pagination: {
      links: [],
      page: 1,
    },
    isOpenFilter: false,
    isStandartsVisible: true,
    apiError: false,
    preselected: [
      {
        class: "metricISO",
        frequency: ["DC SI", "50 Hz SI"],
        range: {
          foerdermenge: {
            unit: "l/min",
          },
          foerderhoehe: {
            unit: "m",
          },
        },
      },
      {
        class: "metricISO",
        frequency: ["60 Hz SI"],
        group: 0,
      },
    ],
  };

  constructor() {
    super();
    this.state.searched = window.location.search;

    this.switchFilter = (i) => () => {
      this.setState({
        activeFilter: i,
      });

      let preselected = this.getPreselected(i);

      this.props.setRequest(preselected);
      this.props.setActiveFilter(this.state.filters[i].id);
    };
    this.toggleFilter = () => {
      this.setState({
        isOpenFilter: !this.state.isOpenFilter,
      });
    };
    this.closeFilter = () => {
      this.setState({
        isOpenFilter: false,
      });
    };
    this.getPreselected = (i) => {
      let preselected = this.state.preselected[i];

      if (preselected.hasOwnProperty("group")) {
        const group = this.state.filters[i].groups[preselected.group].id;
        preselected.groups = [group];

        delete preselected.group;
      }

      return preselected;
    };
  }
  componentDidUpdate() {
    if (
      this.state.searched.length > 0 &&
      this.props.productLoading == false &&
      this.props.filterLoading == false
    ) {
      const request = unflattenQueryString(this.state.searched.substring(1));

      request.frequency =
        request.frequency != undefined ? Object.values(request.frequency) : [];
      request.groups =
        request.groups != undefined ? Object.values(request.groups) : [];

      if (request.options != undefined) {
        for (const [key, value] of Object.entries(request.options)) {
          request.options[key] = Object.values(request.options[key]);
        }
      }

      const activeFilter = this.state.filters.findIndex(
        (filter) => filter.id == request.maingroup
      );

      if (activeFilter >= 0) {
        this.props.setRequest(request);
        this.props.setActiveFilter(this.state.filters[activeFilter].id);

        this.setState({
          searched: "",
          activeFilter: activeFilter,
        });
      }
    }
  }
  componentDidMount() {
    api.getFilters().then((data) => {
      if (!data || !Array.isArray(data.filters)) {
        throw new Error("Invalid filters API response");
      }

      this.setState(
        {
          filters: data.filters,
        },
        () => {
          let preselected = this.getPreselected(0);
          this.props.setRequest(preselected);
          this.props.setActiveFilter(data.filters[0].id);
        }
      );
    }).catch((error) => {
      console.error("Unable to load Product finder filters", error);
      this.setState({ apiError: true });
    });
  }
  render() {
    const { t } = this.props;

    if (this.state.apiError) {
      return (
        <div id="page-wrapper">
          <section className="top-section">
            <div className="top-section-container">
              <h1>{t("Product finder")}</h1>
              <p>{t("Unable to load products. Please try again later.")}</p>
            </div>
          </section>
        </div>
      );
    }

    return (
      <div id="page-wrapper">
        <section className="top-section">
          <div className="top-section-container">
            <h1>{t("Product finder")}</h1>
          </div>
        </section>

        <section className="container-fluid">
          <div className="container">
            <div className="mobile-nav">
              <div
                className={
                  "openfilter-mob" + (this.state.isOpenFilter ? " open" : "")
                }
                onClick={(e) => {
                  this.toggleFilter();
                }}
              ></div>
              <h3>Filter</h3>
              <div
                className={
                  "close-filter" + (this.state.isOpenFilter ? " open" : "")
                }
                onClick={(e) => {
                  this.closeFilter();
                }}
              ></div>
            </div>
            <div className="page-content">
              <div
                className={
                  "column-left-container" +
                  (this.state.isOpenFilter ? " open" : "")
                }
              >
                <div className="filter-container wide">
                  {/* <h2>Filter</h2> */}
                  <div>
                    {this.state.filters.map((filter, i) => {
                      if (this.state.activeFilter == i) {
                        return (
                          <Filter
                            key={i}
                            id={filter.id}
                            preselected={this.state.preselected[i]}
                            filters={this.state.filters}
                            activeFilter={this.state.activeFilter}
                            switchFilter={this.switchFilter}
                            powers={this.props.powers}
                          />
                        );
                      }
                    })}
                  </div>
                  <div className="clear-both"></div>
                </div>
                <div className="clear-both"></div>
              </div>
              <div className="list-container">
                <Products />
              </div>
              <div className="clear-both"></div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    request: state.filter.request,
    powers: state.filter.filter.powers,
    productLoading: state.filter.productLoading,
    filterLoading: state.filter.filterLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setActiveFilter: (args) => (dispatch) => {
        dispatch(setActiveFilterId(args));
        dispatch(getFilter());
        dispatch(getProducts());
      },
      getFilters: (args) => (dispatch) => {
        dispatch(getFilters());
      },
      setRequest: (args) => (dispatch) => {
        dispatch(setRequest(args));
      },
      requestProducts: (args) => (dispatch) => {
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(List));
